<template>
  <page-view class="page-contract-search mwclg-style">
    <div slot="pageRight">
      <!-- <div class="order-search">
        <p class="title">{{ $t('ServiceEvaluation.EvaluationQuery') }}</p>
        <div class="flex">
          <el-form
            ref="searchForm"
            :model="searchForm"
            style="flex: 1"
            :label-width="lang == 'zh' ? '100px' : '130px'"
          >
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item :label="$t('ServiceEvaluation.EvaluatedPerson')">
                  <el-autocomplete
                    v-model="searchForm.evalObjectName"
                    :fetch-suggestions="
                      (queryString, cb) =>
                        querySearchAsync(queryString, cb, 'searchForm')
                    "
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                    @select="handleSelect($event, 'search')"
                    size="small"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('ServiceEvaluation.Position')">
                  <el-select
                    v-model="searchForm.evalObjectType"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                    size="small"
                    @change="onSearchPositionChange"
                  >
                    <el-option
                      v-for="item in Object.values(OP_S)"
                      :key="item.id"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('ServiceEvaluation.Department')">
                  <el-input
                    v-model="searchForm.businessType"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item :label="$t('ServiceEvaluation.Evaluator')">
                  <el-input
                    v-model="searchForm.evaluator"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
          <div style="margin-top: 10px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="search"
              >{{ $t('InvoiceInquiry.Inquire') }}</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh-right"
              @click="reset"
              >{{ $t('InvoiceInquiry.Reset') }}</el-button
            >
          </div>
        </div>
      </div> -->
      <div class="order-list">
        <p class="title">{{ $t('ServiceEvaluation.EvaluationList') }}</p>
        <el-button
          type="primary"
          size="mini"
          @click="showAddDialog"
          icon="el-icon-plus"
          >{{ $t('ServiceEvaluation.NewEvaluation') }}</el-button
        >
        <p style="margin-top: 20px; word-break: break-all; line-height: 20px">
          {{ $t('ServiceEvaluation.utterance') }}
        </p>
        <div class="table_content">
          <el-table
            v-loading="loading"
            :data="contractList"
            stripe
            style="width: 100%"
          >
            <el-table-column
              prop="evalObjectName"
              :width="lang == 'zh' ? '100' : '160'"
              :label="$t('ServiceEvaluation.EvaluatedPerson')"
            >
            </el-table-column>
            <!-- <el-table-column
              :width="lang == 'zh' ? '110' : '220'"
              prop="evalObjectType"
              :label="$t('ServiceEvaluation.EvaluationPersonnelPositions')"
            >
            </el-table-column> -->
            <el-table-column
              width="150"
              prop="businessType"
              :label="$t('ServiceEvaluation.Department')"
            >
            </el-table-column>
            <el-table-column
              prop="attitudeScore"
              :width="lang == 'zh' ? '100' : '130'"
              :label="$t('ServiceEvaluation.ServiceAttitude')"
            >
            </el-table-column>
            <el-table-column
              prop="onTimeScore"
              :width="lang == 'zh' ? '100' : '130'"
              :label="$t('ServiceEvaluation.TimelyResponse')"
            >
            </el-table-column>
            <el-table-column
              prop="changeOrderScore"
              :width="lang == 'zh' ? '100' : '150'"
              :label="$t('ServiceEvaluation.BusinessCapability')"
            >
            </el-table-column>
            <el-table-column
              prop="behaviorScore"
              :width="lang == 'zh' ? '130' : '180'"
              :label="$t('ServiceEvaluation.ProfessionalCompetence')"
            >
            </el-table-column>
            <el-table-column
              prop="totalScore"
              :label="$t('ServiceEvaluation.Score')"
            >
            </el-table-column>
            <el-table-column
              prop="opinion"
              :show-overflow-tooltip="true"
              :label="$t('ServiceEvaluation.Advice')"
            >
            </el-table-column>
            <el-table-column
              width="150"
              prop="evalDate"
              :label="$t('ServiceEvaluation.EvaluationTime')"
            >
            </el-table-column>
            <el-table-column
              prop="evaluator"
              :label="$t('ServiceEvaluation.Evaluator')"
            >
            </el-table-column>
          </el-table>
        </div>
        <el-dialog
          :title="$t('ServiceEvaluation.NewEvaluation')"
          :visible.sync="dialogFormVisible"
        >
          <el-form
            :model="addForm"
            label-position="top"
            :rules="rules"
            ref="addForm"
          >
            <el-row :gutter="10">
              <!-- <el-col :span="12">
                <el-form-item
                  :label="$t('ServiceEvaluation.EvaluationPersonnelPositions')"
                  prop="evalObjectType"
                >
                  <el-select
                    v-model="addForm.evalObjectType"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                    size="small"
                    @change="onAddPositionChange"
                  >
                    <el-option
                      v-for="item in Object.values(OP_S)"
                      :key="item.id"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="24">
                <el-form-item
                  :label="$t('ServiceEvaluation.EvaluatedPerson')"
                  prop="evalObjectCode"
                >
                  <!-- <el-input v-model="addForm.appraisedPerson" autocomplete="off"></el-input> -->
                  <el-autocomplete
                    v-model="addForm.evalObjectName"
                    :trigger-on-focus="false"
                    :fetch-suggestions="
                      (queryString, cb) =>
                        querySearchAsync(queryString, cb, 'editForm')
                    "
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                    @select="handleSelect"
                    size="small"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="$t('ServiceEvaluation.Evaluator')"
                  prop="evaluator"
                >
                  <el-input
                    v-model="addForm.evaluator"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('ServiceEvaluation.EvaluatorEmail')"
                  prop="evalCall"
                >
                  <el-input
                    v-model="addForm.evalCall"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="$t('ServiceEvaluation.ServiceAttitude')"
                  prop="attitudeScore"
                >
                  <el-rate v-model="addForm.attitudeScore" allow-half>
                  </el-rate>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('ServiceEvaluation.TimelyResponse')"
                  prop="onTimeScore"
                >
                  <el-rate v-model="addForm.onTimeScore" allow-half> </el-rate>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="$t('ServiceEvaluation.BusinessCapability')"
                  prop="changeOrderScore"
                >
                  <el-rate v-model="addForm.changeOrderScore" allow-half>
                  </el-rate>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('ServiceEvaluation.ProfessionalCompetence')"
                  prop="behaviorScore"
                >
                  <el-rate v-model="addForm.behaviorScore" allow-half>
                  </el-rate>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  :label="$t('ServiceEvaluation.Advice')"
                  prop="opinion"
                >
                  <el-input
                    v-model="addForm.opinion"
                    type="textarea"
                    maxlength="200"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">{{
              $t('ServiceEvaluation.Cancel')
            }}</el-button>
            <el-button type="primary" @click="add" v-loading="loading">{{
              $t('ServiceEvaluation.Confirm')
            }}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components';
// import TableList from './modules/tableList'
// import { GetARByCusID } from '@/api/order'
// import { USER_INFO } from '@/store/mutation-types'
// import { addEvaluation, getEvaluation } from '@/api/serviceRating'
import i18n from '@/i18n/i18n';
import {
  getEvaluation,
  getCusOpAndSales,
  addEvaluation,
} from '@/api/serviceRating.js';
export default {
  name: 'InvoiceSearch',
  components: { PageView },
  data() {
    const checkStar = (rule, value, cb) => {
      if (value > 0) {
        return cb();
      } else {
        cb(new Error(i18n.t('InvoiceInquiry.PleaseEnter')));
      }
    };
    return {
      OP_S: [
        {
          name: i18n.t('InvoiceInquiry.CustomerService'),
          id: 0,
          value: '客服',
        },
        { name: i18n.t('InvoiceInquiry.Sales'), id: 1, value: '销售' },
      ],
      searchForm: {
        evalObjectName: '',
        businessType: '',
        evalObjectCode: '',
        evalObjectType: '',
        evaluator: '',
      },
      addForm: {
        evalObjectCode: '',
        evalObjectType: '',
        evalObjectName: '',
        evalCall: '',
        attitudeScore: null,
        onTimeScore: null,
        changeOrderScore: null,
        behaviorScore: null,
        opinion: '',
        evaluator: '',
        businessType: '',
      },
      rules: {
        evalObjectCode: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseEnter'),
            trigger: 'blur',
          },
        ],
        evalObjectType: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseSelect'),
            trigger: 'blur',
          },
        ],
        evalCall: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseEnter'),
            trigger: 'blur',
          },
        ],
        attitudeScore: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseEnter'),
            trigger: 'blur',
          },
          { validator: checkStar, trigger: 'blur' },
        ],
        onTimeScore: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseEnter'),
            trigger: 'blur',
          },
          { validator: checkStar, trigger: 'blur' },
        ],
        changeOrderScore: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseEnter'),
            trigger: 'blur',
          },
          { validator: checkStar, trigger: 'blur' },
        ],
        behaviorScore: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseEnter'),
            trigger: 'blur',
          },
          { validator: checkStar, trigger: 'blur' },
        ],
        opinion: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseEnter'),
            trigger: 'blur',
          },
        ],
        evaluator: [
          {
            required: true,
            message: i18n.t('InvoiceInquiry.PleaseEnter'),
            trigger: 'blur',
          },
        ],
      },
      loading: false,
      contractList: [],
      dialogFormVisible: false,
      lang: 'zh',
    };
  },
  created() {
    this.search();
    this.lang = this.$ls.get('lang');
  },
  methods: {
    showAddDialog() {
      this.addForm = {
        evalObjectCode: '',
        evalObjectType: '',
        evalObjectName: '',
        evalCall: '',
        attitudeScore: null,
        onTimeScore: null,
        changeOrderScore: null,
        behaviorScore: null,
        opinion: '',
        evaluator: '',
        businessType: '',
      };
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
      });
      this.dialogFormVisible = true;
    },
    search() {
      this.loading = true;
      getEvaluation(this.searchForm)
        .then((res) => {
          this.loading = false;
          let contractList = res.data;
          if (contractList.length) {
            contractList = contractList.map((item) => {
              return {
                evalObjectName: item.evalObjectName,
                attitudeScore: +item.attitudeScore,
                behaviorScore: +item.behaviorScore,
                changeOrderScore: +item.changeOrderScore,
                businessType: item.businessType,
                evalCall: item.evalCall,
                evalDate: item.evalDate,
                evalObjectCode: item.evalObjectCode,
                evalObjectType: item.evalObjectType,
                evaluator: item.evaluator,
                isMeeted: item.isMeeted,
                onTimeScore: +item.onTimeScore,
                opinion: item.opinion,
                totalScore:
                  +item.attitudeScore +
                  +item.behaviorScore +
                  +item.changeOrderScore +
                  +item.onTimeScore,
              };
            });
            this.contractList = contractList;
          } else {
            this.contractList = [];
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    add() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.addForm.evalObjectType = '销售';
          await addEvaluation(this.addForm);
          this.search();
        }
      });
    },
    onSearchPositionChange(val) {
      this.searchForm.evalObjectName = '';
    },
    onAddPositionChange(val) {
      this.addForm.evalObjectName = '';
    },
    async querySearchAsync(queryString, cb, type) {
      let queryData = {};
      if (type === 'editForm') {
        queryData = {
          fullName: queryString || undefined,
          // postion: this.addForm.evalObjectType || undefined,
        };
      } else {
        queryData = {
          fullName: queryString || undefined,
          postion: this.searchForm.evalObjectType || undefined,
        };
      }
      let { data } = await getCusOpAndSales(queryData);
      console.log(JSON.parse(localStorage.getItem('pro__lang')));
      if (data && data.length) {
        data = data.map((item) => {
          return {
            value:
              JSON.parse(localStorage.getItem('pro__lang')).value == 'en'
                ? `${item.fullName ? item.fullName : ''} - ${item.buNameEn ? item.buNameEn : ''}`
                : `${item.fullName ? item.fullName : ''} - ${item.buName ? item.buName : ''}`,
            type: item.fullName,
            evalObjectCode: item.account,
            businessType:
              JSON.parse(localStorage.getItem('pro__lang')).value == 'en'
                ? (item.departmentNameEn || item.departmentName)
                : item.departmentName,
            evalObjectType: item.postion,
          };
        });
      } else if (data) {
        data.push({
          value: i18n.t('ServiceEvaluation.notQueried'),
          type: i18n.t('ServiceEvaluation.notQueried'),
        });
      }
      cb(data);
    },
    handleSelect(item, val) {
      if (val === 'search') {
        this.searchForm.evalObjectName = item.type;
        this.searchForm.evalObjectCode = item.evalObjectCode;
        this.searchForm.businessType = item.businessType;
        this.searchForm.evalObjectType = item.evalObjectType;
      } else {
        this.addForm.evalObjectName = item.type;
        this.addForm.evalObjectCode = item.evalObjectCode;
        this.addForm.businessType = item.businessType;
        this.$refs.addForm.validateField('evalObjectCode');
      }
    },
    reset() {
      this.searchForm = {
        evalObjectName: '',
        businessType: '',
        evalObjectCode: '',
        evalObjectType: '',
        evaluator: '',
      };
      this.search();
    },
  },
};
</script>
<style lang="less">
.page-contract-search {
  padding: 10px;
  background: #f0f6fb;
  // .plr25 {
  //   padding-left: 0px !important;
  //   padding-right: 0px !important;
  // }
  // .ptb25 {
  //   padding-top: 0px !important;
  //   padding-bottom: 0px !important;
  // }
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    // min-height:60vh;
    .list-item {
      margin-bottom: 8px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .table_content {
    margin-top: 20px;
  }
}
</style>
<style>
.el-select,
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.tms-style .el-input__inner,
.tms-style .el-select--small,
.tms-style .el-input__inner {
  max-width: none;
}
.el-autocomplete {
  width: 100%;
}
.el-loading-mask {
  z-index: 1000;
}
.el-dialog {
  width: 30%;
  min-width: 400px;
}
.el-select,
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  background: none !important;
}
/* .el-autocomplete-suggestion{
  top: 339px !important;
} */
</style>
